import PpImage from './PpImage';

export * from './PpImage';
export default PpImage;
